import { Subscription } from 'rxjs';
import { LinhaService } from './../../providers/linha.service';
import { DirectionsRenderer } from '@ngui/map';
import { Component, OnInit, OnDestroy, Output, EventEmitter, ChangeDetectorRef, ViewChild, Input } from '@angular/core';

@Component({
  selector: 'app-trajetos',
  templateUrl: './trajetos.component.html',
  styleUrls: ['./trajetos.component.scss']
})
export class TrajetosComponent implements OnInit, OnDestroy {

  sub: Subscription;
  linhasList = [];
  @Input() selected:number;
  linhaSelected = new Object();
  @Output() sendTrajeto = new EventEmitter<any>();
  @ViewChild(DirectionsRenderer) directionsRendererDirective: DirectionsRenderer;
  code: string;
  directionsRenderer: google.maps.DirectionsRenderer;
  directionsResult: google.maps.DirectionsResult;

  direction: any = {
    origin: '',
    destination: '',
    waypoints: [],
    optimizeWaypoints: true,
    travelMode: 'DRIVING',
  };

  constructor(
    private linhas: LinhaService,
    private cdr: ChangeDetectorRef,
  ) { }

  ngOnInit() {
    this.loadLinhas();
    this.loadingLinha();
    // this.directionsRendererDirective['initialized$'].subscribe( directionsRenderer => {
    //   this.directionsRenderer = directionsRenderer;
    // });
  }

  directionsChanged() {
    this.directionsResult = this.directionsRenderer.getDirections();
    this.cdr.detectChanges();
  }

  showDirection() {
    this.directionsRendererDirective['showDirections'](this.direction);
  }

  loadLinhas() {
    this.sub = this.linhas.getLinhas()
    .subscribe(data => {
      this.linhasList = data.linhas;
    });
  }

  changeLinha(linha) {
    this.loadingLinha();
  }

  loadingLinha() {
    this.sub = this.linhas.getLinhaById(this.selected).
    subscribe(data => {
      this.linhaSelected = data;
      // this.direction = this.linhas.convertTrajeto(data.vias[0].itinerarios[0].itinerario);
      this.sendTrajeto.emit(this.linhaSelected);
    });
  }


  ngOnDestroy() {
    this.sub.unsubscribe();
  }


}
